<div class="auth-page-wrap">

    <div class="auth-page-body">

        <div class="auth-panel" @fadeIn>

            <logo class="auth-header-logo">
            </logo>

            <div class="auth-body">

                <div class="auth-body-top">

                    <div class="auth-body-title rpc-title-font">
                        {{ 'RESTORE_PASSWORD.TITLE' | translate }}
                    </div>

                    <div class="auth-body-text">
                        {{ 'RESTORE_PASSWORD.RESTORE_EXPLANATION' | translate }}
                    </div>

                </div>

                <form class="auth-form" name="restorePasswordForm" [formGroup]="restorePasswordForm" novalidate>

                    <div class="auth-form-body">

                        <password class="auth-form-input" [autocomplete]="'current-password'"
                            [label]="'RESTORE_PASSWORD.FIELDS.PASSWORD'" [options]="passwordControlOptions">
                        </password>

                        <password class="auth-form-input" [autocomplete]="'current-password'"
                            [label]="'RESTORE_PASSWORD.FIELDS.PASSWORD_CONFIPMATION'"
                            [options]="passwordConfirmControlOptions">
                        </password>

                    </div>

                    <div class="auth-form-footer">

                        <rpc-button class="auth-submit-button" [color]="'accent'" [isMainButton]="true"
                            [disabled]="restorePasswordForm.invalid" [appearanceType]="'flat'"
                            [text]="'RESTORE_PASSWORD.TITLE'" (clicked)="restorePassword()">
                        </rpc-button>

                    </div>

                </form>

            </div>

        </div>

    </div>

</div>

<additional-footer class="global-additional-footer">
</additional-footer>